export const initialFilters = {
    ratings: [],
    tags: [],
    languages: [],
    stations: [],
    verified: 1,
    company: "",
}